{
    "PartitionList_Column_Description": "Descrizione",
    "PartitionList_Column_IDInTelSys": "ID",
    "PartitionList_Column_Licence": "Licenza",
    "PartitionList_Column_Extensions": "Estensioni",
    "PartitionList_Column_AcdAgents": "agenti",
    "PartitionList_Column_AppUsers": "Utenti",
    "PartitionList_Column_SyncType": "Tipo di sincronizzazione",
    "PartitionList_Column_Status": "Stato",
    "PartitionList_Filter_Licence": "Licenza",
    "PartitionList_CountLink_ExtensionsAria": "Visualizza i dispositivi in ​​questa partizione",
    "PartitionList_CountLink_AcdAgentsAria": "Visualizza gli agenti ACD in questa partizione",
    "PartitionList_CountLink_AppUsersAria": "Visualizza gli utenti dell'app in questa partizione",
    "PartitionList_Add_Disabled_SelectTelephonyServer": "Selezionare un server di telefonia per aggiungere una partizione.",
    "NAME": "Elenco delle partizioniLingua"
}